import { Stack, Text, Title } from '@mantine/core'
import { TwContainer } from '@/lib/components/TwContainer'

export const StiSectionOne = () => {
	return (
		<section
			style={{
				backgroundImage: 'url(/images/img_27.webp)',
				backgroundSize: 'cover',
				backgroundRepeat: 'no-repeat',
				backgroundPosition: 'center',
				minHeight: '480px',
			}}
			className={'h-96'}
		>
			<TwContainer className={'justify-center items-center'} fill>
				<Stack className={' my-auto'} align={'center'}>
					<Title variant={'title'} className={'max-w-2xl'}>
						Comprehensive Sexual Transmitted Infections (STI) Testing and Information at Wellview Care
					</Title>
					<Text ta={'center'} className={'max-w-4xl md:px-3'}>
						Welcome to Wellview Care, your trusted source for STI / STD testing, diagnosis, treatment, and education. We understand the importance of
						sexual health and offer comprehensive services in a discreet and confidential environment.
					</Text>
				</Stack>
			</TwContainer>
		</section>
	)
}
